export const DASHBOARD = "/dashboard";
export const TEMPLATES = "/templates";
export const COMPANY_TEMPLATES ="/company-templates"
export const LOGIN = "/login";
export const LOGOUT = "/logout";
export const PROFILE = "/profile";
export const REPORTS = "/reports";
export const PNL_SUMMARY_REPORTS = "/pnl-summary-reports"
export const TIME_WISE_GRAPH_REPORTS = "/time-wise-graph-reports";
export const TIME_WISE_SUMMARY_REPORTS = "/time-wise-summary-reports";
export const TIME_WISE_MULTIDAY_REPORTS = "/time-wise-detail-report"

export const DAY_GRAPH_REPORT = "/day-graph-reports";
export const DAY_SUMMARY_REPORT = "/day-summary-reports";
export const DAY_MULTIDAY_REPORTS = "/day-detail-report"

export const OPERATOR_SUMMARY_REPORT = "/operator-summary-reports";
export const OPERATOR_DETAIL_REPORT = "/operator-detail-reports";

export const PART_SUMMARY_REPORT = "/part-summary-reports";
export const PART_DETAIL_REPORT = "/part-detail-reports";

export const PERFORMANCE_REPORT = "/performance-reports";
export const SETTING = "/setting";

export const COMPANY_SETTINGS = "/company-settings";
export const SHIFT_SETTING = "/shift-settings";
export const PART_SETTING = "/parts-settings";

export const OPERATOR_SETTING='/operator-settings'
export const STAFF_SETTING='/staff-settings'


export const BREAKDOWN = '/breakdown';
export const BREAKDOWN_REPORT ="/breakdown-report"
export const BREAKDOWN_SETTINGS ="/breakdown-settings";
export const BREAKDOWN_ANALYSIS = "/breakdown-analysis";

export const PRODUCTION_COMPONENT = '/production-component'
export const NOTIFICATION_SETTINGS = '/notification-settings'